import React, { useEffect, useMemo, useRef, useState } from 'react';
import _ from 'lodash-es';
import { getLocale, useIntl, useRouteMatch } from 'umi';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointPage, buriedPointSearch } from '@/pages/home/utils/buriedPoint';
import { filterMetricsRecordsBySearch } from '../../searchUtils';
import { getMetrics } from '@/pages/intelligence/services/sourceMetrics';
import { isEmpty } from '@/pages/intelligence/utils/commonUtils';
export const useSourcesTables = () => {
  const { params }: any = useRouteMatch() || {};
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const refCloneList = useRef([]);
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const [dataSourceList, setDataSourceList] = useState<any>([]);
  const tabId = params?.tab;

  const pageLogMes = useMemo(() => {
    const log = {
      OpinionsMetrics: dbiPageLogMes.sourcesMetricsMetricsOpinionsMetrics,
      MobileGameFields: dbiPageLogMes.sourcesMetricsMetricsMobileGameFields,
      PCConsoleFields: dbiPageLogMes.sourcesMetricsMetricsPCConsoleFields,
      CompanyFields: dbiPageLogMes.sourcesMetricsMetricsCompanyFields,
      DeviceMetrics: dbiPageLogMes.sourcesMetricsMetricsDeviceMetrics,
    }[tabId as string];
    return log;
  }, [tabId]);

  const getData = () => {
    setLoading(true);
    const tab = {
      OpinionsMetrics: 'opinions',
      MobileGameFields: 'mobile',
      PCConsoleFields: 'pc,console',
      CompanyFields: 'company',
      DeviceMetrics: 'device',
    }[tabId as string];

    if (!isEmpty(tab)) {
      getMetrics({ tab })
        .then((data) => {
          refCloneList.current = data;
          setDataSourceList(findLanguageList(data));
        })
        .catch((err) => {
          Promise.reject(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
    buriedPointPage(pageLogMes);
    return () => {
      refCloneList.current = [];
    };
  }, []);

  useEffect(() => {
    setDataSourceList(findLanguageList(refCloneList.current, searchValue));
  }, [locale]);

  // 搜索
  const handleOnSearchTextList = _.debounce((value: string) => {
    if (!value) return;
    if (pageLogMes?.pageId) {
      buriedPointSearch({ extInfo: pageLogMes?.pageId, typeId: pageLogMes?.typeId }, searchValue);
    }
    setDataSourceList(findLanguageList(refCloneList.current, value));
  }, 200);
  // 清空
  const handleOnSearchClear = () => {
    setDataSourceList(findLanguageList(refCloneList.current));
  };
  // 输入
  const handleOnChangeText = (word: string) => {
    setSearchValue(word);
    if (word == '') {
      handleOnSearchClear();
    } else if (word.replace(/^\s*/g, '')) {
      handleOnSearchTextList(word);
    }
  };
  const findLanguageList = <T extends unknown>(data: T[], value?: string) => {
    if (_.isEmpty(data)) return [];
    const language = getLocale() === 'en-US' ? 'en' : 'cn';
    let list = _.get(_.find(data, { language }), 'list', []);
    if (value) {
      list = filterMetricsRecordsBySearch(list, value);
    }
    return list.map((task, taskIndex) => ({ ...task, id: taskIndex + 1 }));
  };

  return {
    loading,
    formatMessage,
    searchValue,
    dataSourceList,
    handleOnSearchTextList,
    handleOnSearchClear,
    handleOnChangeText,
    locale,
  };
};
